/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        type: "function",
        name: "getReservesData",
        inputs: [
            {
                name: "provider",
                type: "address",
                internalType: "contract IPoolAddressesProvider",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple[]",
                internalType: "struct IUIPoolDataProvider.AggregatedReserveData[]",
                components: [
                    {
                        name: "underlyingAsset",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "name",
                        type: "string",
                        internalType: "string",
                    },
                    {
                        name: "symbol",
                        type: "string",
                        internalType: "string",
                    },
                    {
                        name: "decimals",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "baseLTVasCollateral",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "reserveLiquidationThreshold",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "reserveLiquidationBonus",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "reserveFactor",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "usageAsCollateralEnabled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "borrowingEnabled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "isActive",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "isFrozen",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "isPaused",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "liquidityIndex",
                        type: "uint128",
                        internalType: "uint128",
                    },
                    {
                        name: "variableBorrowIndex",
                        type: "uint128",
                        internalType: "uint128",
                    },
                    {
                        name: "liquidityRate",
                        type: "uint128",
                        internalType: "uint128",
                    },
                    {
                        name: "variableBorrowRate",
                        type: "uint128",
                        internalType: "uint128",
                    },
                    {
                        name: "lastUpdateTimestamp",
                        type: "uint40",
                        internalType: "uint40",
                    },
                    {
                        name: "yTokenAddress",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "variableDebtTokenAddress",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "interestRateStrategyAddress",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "availableLiquidity",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "totalScaledVariableDebt",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "priceInMarketReferenceCurrency",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "priceOracle",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "variableRateSlope1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "variableRateSlope2",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "baseVariableBorrowRate",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "optimalUsageRatio",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "accruedToTreasury",
                        type: "uint128",
                        internalType: "uint128",
                    },
                    {
                        name: "flashLoanEnabled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "borrowCap",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "supplyCap",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "",
                type: "tuple",
                internalType: "struct IUIPoolDataProvider.BaseCurrencyInfo",
                components: [
                    {
                        name: "marketReferenceCurrencyUnit",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "marketReferenceCurrencyPriceInUsd",
                        type: "int256",
                        internalType: "int256",
                    },
                    {
                        name: "networkBaseTokenPriceInUsd",
                        type: "int256",
                        internalType: "int256",
                    },
                    {
                        name: "networkBaseTokenPriceDecimals",
                        type: "uint8",
                        internalType: "uint8",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getReservesList",
        inputs: [
            {
                name: "provider",
                type: "address",
                internalType: "contract IPoolAddressesProvider",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getUserReservesData",
        inputs: [
            {
                name: "provider",
                type: "address",
                internalType: "contract IPoolAddressesProvider",
            },
            {
                name: "user",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple[]",
                internalType: "struct IUIPoolDataProvider.UserReserveData[]",
                components: [
                    {
                        name: "underlyingAsset",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "scaledYTokenBalance",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "usageAsCollateralEnabledOnUser",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "scaledVariableDebt",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "",
                type: "tuple[]",
                internalType: "struct IUIPoolDataProvider.UserERC1155ReserveData[]",
                components: [
                    {
                        name: "asset",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "tokenId",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "balance",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "usdValue",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "ltv",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "liquidationThreshold",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "nTokenAddress",
                        type: "address",
                        internalType: "address",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
];
export class IUIPoolDataProvider__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IUIPoolDataProvider__factory.abi = _abi;
//# sourceMappingURL=IUIPoolDataProvider__factory.js.map